import { ChristmasScavenger4Component } from './pages/christmas-scavenger4/christmas-scavenger4.component';
import { ChristmasScavenger3Component } from './pages/christmas-scavenger3/christmas-scavenger3.component';
import { ChristmasScavenger2Component } from './pages/christmas-scavenger2/christmas-scavenger2.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CssFunComponent } from './pages/css-fun/css-fun.component';
import { HomeComponent } from './pages/home/home.component';
import { BoredComponent } from './pages/bored/bored.component';
import { MessagesComponent } from './pages/messages/messages.component';
import { PixelizeComponent } from './pages/pixelize/pixelize.component';
import { CustomGridComponent } from './pages/custom-grid/custom-grid.component';
import { MuscleBeachComponent } from './pages/muscle-beach/muscle-beach.component';
// import { PlatformerComponent } from './pages/platformer/platformer.component';
import { PhaserComponent } from './pages/phaser/phaser.component';
import { CoupComponent } from './pages/coup/coup.component';
import { GamesComponent } from './pages/games/games.component';
import { CouphomeComponent } from './pages/couphome/couphome.component';
import { TravelStuffComponent } from './pages/travel-stuff/travel-stuff.component';
import { ChecklistComponent } from './pages/checklist/checklist.component';
import { InstaComponent } from './pages/insta/insta.component';
import { AuthComponent } from './pages/auth/auth.component';
import { SwolecityComponent } from './pages/swolecity/swolecity.component';
import { NachoGalleryComponent } from './pages/nacho-gallery/nacho-gallery.component';
import { ShowDemosComponent } from './pages/show-demos/show-demos.component';
import { JsFunComponent } from './pages/js-fun/js-fun.component';
import { PlantsComponent } from './pages/plants/plants.component';
import { ChristmasScavengerComponent } from './pages/christmas-scavenger/christmas-scavenger.component';
import {StitchMakerComponent} from './pages/stitch-maker/stitch-maker.component';
import {WeddingRsvpComponent} from './pages/wedding-rsvp/wedding-rsvp.component';
import { BridalShowerQuestionsComponent } from './pages/bridal-shower-questions/bridal-shower-questions.component';
import { WeddingRsvpAdminComponent } from './pages/wedding-rsvp-admin/wedding-rsvp-admin.component';
import { ChallengeComponent } from './pages/challenge/challenge.component';
import { DraftComponent } from './pages/draft/draft.component';
import { GuitarAppComponent } from './pages/guitar-app/guitar-app.component';
import { GuitarLessonsComponent } from './pages/guitar-app/lessons.component';
import { GuitarVisualizerComponent } from './pages/guitar-app/visualizer.component';
import { LessonDetailComponent } from './pages/guitar-app/lesson-detail.component';
import { WorkoutTrackerComponent } from './pages/workout-tracker/workout-tracker.component';
import { LoginComponent } from './pages/login/login.component';
import {AuthGuard} from "./pages/auth/auth.guard";
import { ItineraryComponent } from './pages/itinerary/itinerary.component';
import { RecipeListComponent } from './pages/recipe/recipe-list/recipe-list.component';
import { RecipeDetailComponent } from './pages/recipe/recipe-detail/recipe-detail.component';
import { PcbStatorComponent } from './pages/pcb-stator/pcb-stator.component';
import { RenFaireComponent } from './pages/ren-faire/ren-faire.component';
import { BlacksmithingComponent } from './pages/blacksmithing/blacksmithing.component';
import { BlacksmithingJournalComponent } from './pages/blacksmithing/blacksmithing-journal.component';
import { BlacksmithingGalleryComponent } from './pages/blacksmithing/blacksmithing-gallery.component';
import { MachiningComponent } from './pages/machining/machining.component';
import { MachiningJournalComponent } from './pages/machining/machining-journal.component';
import { MachiningGalleryComponent } from './pages/machining/machining-gallery.component';
import { AdobeIllustratorComponent } from './pages/adobe-illustrator/adobe-illustrator.component';
import { VawtTrackerComponent } from './pages/vawt-tracker/vawt-tracker.component';
import { HoursTrackerComponent } from './pages/hours-tracker/hours-tracker.component';
import { NewInternetComponent } from './pages/new-internet/new-internet.component';
import { MoneyManagerComponent } from './pages/money-manager/money-manager.component';
import { TransactionsComponent } from './pages/money-manager/transactions/transactions.component';
import { CategoriesComponent } from './pages/money-manager/categories/categories.component';
import { ImportComponent } from './pages/money-manager/import/import.component';
import { DashboardComponent } from './pages/money-manager/dashboard/dashboard.component';
import { BudgetsComponent } from './pages/money-manager/budgets/budgets.component';
import { RecurringComponent } from './pages/money-manager/recurring/recurring.component';
import { AccountsComponent } from './pages/money-manager/accounts/accounts.component';
import { SavingsComponent } from './pages/money-manager/savings/savings.component';
import { ReportsComponent } from './pages/money-manager/reports/reports.component';
import { MortgageComponent } from './pages/money-manager/mortgage/mortgage.component';
import { FireComponent } from './pages/money-manager/fire/fire.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'css-fun', component: CssFunComponent },
  { path: 'js-fun', component: JsFunComponent },
  { path: 'bored', component: BoredComponent},
  { path: 'messaging', component: MessagesComponent },
  { path: 'pixelize', component: PixelizeComponent },
  { path: 'custom-grid', component: CustomGridComponent },
  { path: 'muscle-beach', component: MuscleBeachComponent },
  { path: 'swolecity', component: SwolecityComponent },
  // { path: 'game', component: PlatformerComponent },
  { path: 'phaser', component: PhaserComponent },
  { path: 'games',  component: GamesComponent },
  { path: 'coup', component: CouphomeComponent },
  { path: 'coup/:id', component: CoupComponent },
  { path: 'checklist', component: ChecklistComponent },
  { path: 'insta', component: InstaComponent },
  { path: 'auth', component: AuthComponent },
  { path: 'travel-track', component: TravelStuffComponent },
  { path: 'nacho-gallery', component: NachoGalleryComponent },
  { path: 'show-demos', component: ShowDemosComponent },
  { path: 'plants', component: PlantsComponent },
  // { path: 'lol-jake-get-wrecked', component: ChristmasScavengerComponent },
  // { path: 'ho-ho-ho', component: ChristmasScavenger2Component },
  // { path: 'holly-and-jolly', component: ChristmasScavenger3Component },
  // { path: 'way-to-go-jake', component: ChristmasScavenger4Component },
  { path: 'stitch-maker', component: StitchMakerComponent },
  { path: 'wedding-rsvp', component: WeddingRsvpComponent },
  { path: 'bridal-shower-questions', component: BridalShowerQuestionsComponent },
  { path: 'wedding-rsvp-admin', component: WeddingRsvpAdminComponent, canActivate: [AuthGuard] },
  { path: 'challenge', component: ChallengeComponent, canActivate: [AuthGuard] },
  { path: 'draft', component: DraftComponent },
  { path: 'guitar-app', component: GuitarAppComponent, children: [
    { path: '', redirectTo: 'lessons', pathMatch: 'full' },
    { path: 'lessons', component: GuitarLessonsComponent },
    { path: 'lessons/:id', component: LessonDetailComponent },
    { path: 'visualizer', component: GuitarVisualizerComponent },
    // Add chords, scales, progress routes later
  ]},
  { path: 'workout-tracker', component: WorkoutTrackerComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'itinerary', component: ItineraryComponent },
  { path: 'recipe', component: RecipeListComponent, canActivate: [AuthGuard] },
  { path: 'recipe/:id', component: RecipeDetailComponent, canActivate: [AuthGuard] },
  { path: 'pcb-stator', component: PcbStatorComponent },
  { path: 'ren-faire', component: RenFaireComponent },
  { path: 'blacksmithing/journal', component: BlacksmithingJournalComponent, canActivate: [AuthGuard] },
  { path: 'blacksmithing/my-gallery', component: BlacksmithingGalleryComponent, canActivate: [AuthGuard] },
  { path: 'blacksmithing', component: BlacksmithingComponent, canActivate: [AuthGuard] },
  { path: 'machining/journal', component: MachiningJournalComponent, canActivate: [AuthGuard] },
  { path: 'machining/my-gallery', component: MachiningGalleryComponent, canActivate: [AuthGuard] },
  { path: 'machining', component: MachiningComponent, canActivate: [AuthGuard] },
  { path: 'adobe-illustrator', component: AdobeIllustratorComponent, canActivate: [AuthGuard] },
  { path: 'vawt-tracker', component: VawtTrackerComponent, canActivate: [AuthGuard] },
  { path: 'hours-tracker', component: HoursTrackerComponent },
  { path: 'new-internet', component: NewInternetComponent, canActivate: [AuthGuard] },
  { path: 'money-manager', component: MoneyManagerComponent, canActivate: [AuthGuard], children: [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'dashboard', component: DashboardComponent },
    { path: 'transactions', component: TransactionsComponent },
    { path: 'categories', component: CategoriesComponent },
    { path: 'budgets', component: BudgetsComponent },
    { path: 'mortgage', component: MortgageComponent },
    { path: 'fire', component: FireComponent },
    { path: 'recurring', component: RecurringComponent },
    { path: 'accounts', component: AccountsComponent },
    { path: 'savings', component: SavingsComponent },
    { path: 'reports', component: ReportsComponent },
    { path: 'import', component: ImportComponent },
  ]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
